export function validation(item) {
	switch(item.type) {
	case 'socials':
		for(let key in item.value) {
			if((item.value[key] && !item.value[key].startsWith(`https://${key}.com`)) &&
					(item.value[key] && !item.value[key].startsWith(`https://www.${key}.com`))) {
				return 'Введена невалидная ссылка на соцсеть';
			}
		}
		break;
	case 'social':
		if((item.value && !item.value.startsWith(`https://${item.socialType}.com`)) &&
			(item.value && !item.value.startsWith(`https://www.${item.socialType}.com`))) {
			return 'Введена невалидная ссылка на соцсеть';
		}
		break;
	case 'website':
		if((item.value.search(/^((https?|ftp)\:\/\/)?([a-z0-9]{1})((\.[a-z0-9-])|([a-z0-9-]))*\.([a-z]{2,4})$/) === -1) || (!item.value.startsWith('https://') && !item.value.startsWith('http://'))) {
			return 'Введите корректный адрес сайта';
		}
		break;
	case 'lastName':
		if(item.value.length < 1 || item.value.length > 255) {
			return 'Фамилия должна содержать от 1 до 255 символов';
		}
		break;
	case 'file':
		if(!item.value) {
			return 'Необходимо загрузить файл';
		}
		break;
	case 'array':
		if(item.value) {
			let filled = [];
			let specs = item.value;
			for(let key in specs) {
				specs[key].length && filled.push(specs[key]);
			}
			if (filled.length < 1) {
				return 'Необходимо заполнить хотя бы одно поле';
			}
		}
		break;
	case 'name':
		if(item.value.length < 1 || item.value.length > 255) {
			return 'Имя должно содержать от 1 до 255 символов';
		}
		break;
	case 'required':
		if(!item.value || (item.value.length < 1 || item.value.length > 255)) {
			return 'Поле обязательно для заполнения';
		}
		break;
	case 'requiredAddress':
		if(item.value.length < 1 || item.value.length > 255) {
			return 'Необходимо указать адрес';
		}
		break;
	case 'requiredCity':
		if(item.value.length < 1 || item.value.length > 255) {
			return 'Необходимо указать город';
		}
		break;
	case 'coords':
		if(item.value) {
			let coordsArray = item.value.split(', ', 2);
			if(coordsArray.length !== 2) {
				return 'Необходимо задать широту и долготу через запятую';
			}
			coordsArray.forEach((coord, index) => {
				if(index === 0) {
					if (!coord.length || (coord < -90 || coord > 90)) {
						return 'Широта должна быть в диапазоне от -90° до 90°';
					}
				} else {
					if (!coord.length || (coord < 0 || coord > 180)) {
						return ('Долгота должна быть в диапазоне от 0° до 180°');
					}
				}
			});
		} else {
			return 'Необходимо задать координаты';
		}
		break;
	case 'requiredLong':
		if(!item.value.length) {
			return 'Поле обязательно для заполнения';
		}
		break;
	case 'select':
		if(item.value === 0) {
			return 'Поле обязательно для заполнения';
		}
		break;
	case 'postal':
		if(item.value.length !== 6) {
			return 'Индекс должен содержать 6 цифр';
		}
		break;
	case 'email':
	case 'login':
		if(!validateEmail(item.value)) {
			return 'Введите корректный e-mail';
		}
		break;
	case 'phone':
		if(!validatePhone(item.value)) {
			return 'Введите корректный номер телефона';
		}
		break;
	case 'date':
		if(item.value) {
			const today = new Date();
			const dd = today.getDate();
			const mm = today.getMonth() + 1;
			const yyyy = today.getFullYear();
			
			const min = new Date(Date.UTC(yyyy - 18, mm, dd));
			const max = new Date(Date.UTC(yyyy - 80, mm, dd));

			if (item.value < max || item.value > min) {
				return 'Введите корректный возраст';
			}
		}
		break;
	case 'agreement':
		if(!item.value) {
			return 'Необходимо дать согласие на обработку персональных данных';
		}
		break;
	case 'password':
		if(item.value.length < 6) {
			return 'Пароль ненадёжный, используйте от 6 символов';
		} else if(item.value.length > 50) {
			return 'Пароль должен быть не длиннее 50 символов';
		}
		break;
	}
	function validateEmail(email) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
	function validatePhone(phone) {
		const re = /^((\+7|7|8)+([0-9]){10})$/;
		return re.test(String(phone));
	}
}
